<template>
  <el-dialog title="修改联系人信息" :visible.sync="dialogVisible" width="520px" :before-close="handleClose">
    <el-form :model="form" :rules="rules" ref="ruleForm" label-width="82px">
      <el-form-item label="姓名" prop="contact_name">
        <el-input v-model="form.contact_name" placeholder="请输入姓名" />
      </el-form-item>
      <el-form-item label="微信号" prop="wechat_account">
        <el-input v-model="form.wechat_account" placeholder="请输入微信号" maxlength="32" />
      </el-form-item>
      <el-form-item label="手机号" prop="mobile">
        <el-input v-model="form.mobile" placeholder="请输入手机号" />
      </el-form-item>
      <el-form-item label="备注" style="margin: 0">
        <el-input v-model="form.remark" placeholder="请输入备注" />
      </el-form-item>
    </el-form>
    <span slot="footer">
      <el-button type="primary" @click="submit">保 存</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { checkMobile } from '@/utils/validate'
import { editContact } from '@/api/talentCRM';
export default {
  name: 'addContactDialog',
  data () {
    return {
      dialogVisible: false,
      form: {
        contact_name: '',
        mobile: '',
        wechat_account: '',
        contact_id: '',
        remark: ''
      },
      rules: {
        contact_name: { required: true, message: '请输入姓名', trigger: 'blur' },
        wechat_account: { required: true, message: '请输入微信号', trigger: 'blur' },
        mobile: { validator: checkMobile, trigger: 'blur' }
      }
    }
  },
  methods: {
    show({ contact_name = '', mobile = '', wechat_account = '', id: contact_id = '', remark = '' }) {
      this.form = {
        contact_name,
        mobile,
        wechat_account,
        contact_id,
        remark
      }
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
      this.form = {
        contact_name: '',
        mobile: '',
        wechat_account: '',
        contact_id: '',
        remark: ''
      }
      this.$refs.ruleForm.resetFields()
    },
    submit() {
      this.$refs.ruleForm.validate(async valid => {
        if(!valid) return
        const { code } = await editContact(this.form)
        if(code !== 0) return
        this.$message.success('修改成功')
        this.handleClose()
        this.$emit('getList')
      })
    }
  }
}
</script>

<style lang="less" scoped>
</style>
